import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';

import styles from './OrderLineItemInfo.module.scss';
import { Price } from '@components';
import { Typography } from 'gd-design-library';
import { OrderLineItem } from '@services/checkout';
import { getSuccessfullyLoadedUrls } from '@utils';
import NoImagePlaceholder from '@assets/images/no-image-placeholder.png';
import Link from 'next/link';
import { ROUTES } from '@constants';

const CN = 'order-line-item';
const generalSectionClassName = `${CN}--general-section`;
const imageClassName = `${generalSectionClassName}--image`;
const nameClassName = `${generalSectionClassName}--name`;
const infoSectionClassName = `${CN}--info-section`;
const titleClassName = `${infoSectionClassName}--title`;
const totalPriceValueClassName = `${infoSectionClassName}__value`;

const cx = classNames.bind(styles);

interface Props {
  lineItem: OrderLineItem,
}

export const OrderLineItemInfo: React.FC<Props> = ({
  lineItem
}) => {
  const [ imageUrl, setImageUrl ] = useState(NoImagePlaceholder.src);

  useEffect(() => {
    (async (): Promise<void> => {
      const [ loadedUrl ] = await getSuccessfullyLoadedUrls([ lineItem.variant?.imageUrl ?? '' ]);
      setImageUrl(loadedUrl ?? NoImagePlaceholder.src);
    })();
  }, []);

  return (
    <div className={ cx(CN) }>
      <div className={ cx(generalSectionClassName) }>
        <img className={ cx(imageClassName) } src={ imageUrl } />
        <Link href={ `${ROUTES.products}/${lineItem.productId}` }>
          <Typography variant='small' as='span' className={ cx(nameClassName) }>{ lineItem.name }</Typography>
        </Link>
      </div>
      <div className={ cx(infoSectionClassName) }>
        <Typography variant='small' className={ cx(titleClassName) }>Amount</Typography>
        <Typography variant='small' as='span'>{ lineItem.quantity }</Typography>
      </div>
      <div className={ cx(infoSectionClassName) }>
        <Typography variant='small' className={ cx(titleClassName) }>Total</Typography>
        <Typography variant='caption' as='span'>
          <Price className={ cx(totalPriceValueClassName) } price={ lineItem.totalPrice } />
        </Typography>
      </div>
    </div>
  );
};
